export default "__VITE_ASSET__194d3c01__"